import { Attachment } from 'components/FileInput';

export namespace Confluence {
  export enum ETemplateTypes {
    DEFAULT = 'default',
    LESSON = 'lesson',
    POLL = 'poll',
  }

  export enum ESections {
    INTERNAL = 'internal',
    CLIENT = 'client',
  }

  export interface IArticle {
    id?: number;
    name?: string;
    html?: string;
    templateType?: ETemplateTypes;
    section?: ESections;
    parent?: IArticle | null;
    parentId?: number | null;
    hide?: boolean;
    createAt?: string;
    createBy?: string;
    updateAt?: string;
    updateBy?: string;
  }

  export interface IDefaultArticle extends IArticle {}

  export interface ILessonArticle extends IArticle {
    template: {
      area?: IArea | null;
      areaId?: number;
      areaName?: string;
      realEstates?: IRealEstate[];
      zone?: IZone | null;
      zoneId?: number;
      zoneName?: string;
      situation?: string;
      reason?: string;
      solution?: string;
      recommendation?: string;
      effect?: string;
      photoBefore?: Attachment[];
      photoAfter?: Attachment[];
    };
  }

  export interface IPollArticle extends IArticle {
    template: {
      subjectKk: string;
      subjectRu: string;
      descriptionKk: string;
      descriptionRu: string;
      questions: IPollQuestion[];
    };
  }

  export interface IPollQuestion {
    questionKk: string;
    questionRu: string;
  }

  export type IArticleBase = IDefaultArticle | ILessonArticle;

  export type IArticleHistory = IArticle[];

  export interface IMenuItem extends Pick<IArticle, 'name' | 'parentId'> {
    menuId: number;
    hasHtml: boolean;
    child: IMenuItem[] | null;
    templateType?: ETemplateTypes | null;
  }

  export type IMenu = IMenuItem[];
}

export interface IArea {
  areaId?: number;
  name?: string;
}

export interface IRealEstate {
  guid?: string;
  name?: string;
  realEstateGuid?: string;
  realEstateName?: string;
  addressRu?: string;
  addressKk?: string;
}

export interface IZone {
  isDeleted?: boolean;
  zoneId?: number;
  zoneName?: string;
}
